import {
  zlbBudgetAccountSubjectDeletePost,
  zlbBudgetAccountSubjectDetailUniqueCodeGet,
  zlbBudgetAccountSubjectEditPost,
  zlbBudgetAccountSubjectPagingPost,
  zlbBudgetAccountSubjectQueryBalanceDirectionGet,
  zlbBudgetAccountSubjectSavePost,
} from '@/api/zlbBudget';
import {
  accountSubjectConfigOverYear,
  CheckCopyAccountSubject,
  getBudgetAccountSubjectList,
} from '@/routes/OtherFundsOfTheUnit/services';

export default {
  namespace: 'AccountingSubject',
  state: {},
  effects: {
    *getAccountSubjectList({ payload }, { call }) {
      const res = yield call(zlbBudgetAccountSubjectPagingPost, payload);
      return res;
    },
    // 会计科目列表-单位其他资金
    *getOtherFundsSubjectList({ payload }, { call }) {
      const res = yield call(getBudgetAccountSubjectList, payload);
      return res;
    },
    *getAccountSubjectDetail({ payload }, { call }) {
      const res = yield call(zlbBudgetAccountSubjectDetailUniqueCodeGet, payload);
      return res;
    },
    *saveAccountSubject({ payload }, { call }) {
      const res = yield call(zlbBudgetAccountSubjectSavePost, payload);
      return res;
    },
    *editAccountSubject({ payload }, { call }) {
      const res = yield call(zlbBudgetAccountSubjectEditPost, payload);
      return res;
    },
    *deleteAccountSubject({ payload }, { call }) {
      const res = yield call(zlbBudgetAccountSubjectDeletePost, payload);
      return res;
    },
    *getBalanceDirectionList({ payload }, { call }) {
      const res = yield call(zlbBudgetAccountSubjectQueryBalanceDirectionGet, payload);
      return res;
    },
    // 结转科目
    *accountSubjectConfigOverYear({ payload }, { call }) {
      const res = yield call(accountSubjectConfigOverYear, payload);
      return res;
    },
    // 是否可以结转科目
    *CheckCopyAccountSubject({ payload }, { call }) {
      return yield call(CheckCopyAccountSubject, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
